import { Duration } from './types';

export const createTransitionStyle = (properties: string[], duration: Duration) => ({
  transition: properties.map((property) => `${property} ${duration} ease`).join(', '),
});
